import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/account/cancelled/$')({
  beforeLoad: legacyRedirect('/account_canceled'),
});
